export default {
      id: "auto-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#auto-usage",
      toString: function () {
        return this.url;
      }
    }